module.exports = __webpack_public_path__ + "static/media/2022-Bikie-Code-Feature-banner-Mobile@1x.476b4e54.jpg";